/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { useHistory } from "react-router-dom";
import { BlockListUserContainer } from "./container";
import { routes } from "../../services/appNavigatorService/config/routes.config.json";

export const BlockListUserListPage = ({ navigation }: { navigation: any }) => {
  const history = useHistory();
  return (
    <BlockListUserContainer
      onRowClick={(id: string) => {
        // history.push(`${routes?.RowDetail?.path}?id=${id}`);
      }}
      onTogglePress={(id: string) => {
        //history.push(`${routes?.RowDetail?.path}?id=${id}`);
      }}
    />
  );
};
